module.exports = __webpack_public_path__ + "img/77_27.1c427756.png";